import { createContext, useContext } from 'react';

const CustomerSuccessScheduledCallsContext = createContext();

CustomerSuccessScheduledCallsContext.displayName = 'CustomerSuccessScheduledCallsContext';

const useCustomerSuccessScheduledCalls = () => useContext(CustomerSuccessScheduledCallsContext);

export { CustomerSuccessScheduledCallsContext, useCustomerSuccessScheduledCalls };
